import React from 'react';
import classnames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import { Bubble } from '@home/components/TeaComponents';
import TriggerFoldBtn from '@gp/components/TriggerFoldBtn';

import type { IRecord } from '@gp/types/global';
import type { ITabType } from '../types';

interface ICardSlotIconCfg {
  icon: ITabType;
  context: string;
}

const APPROVED_TOTAL_DEV_BUDGET_ICON_LIST: ICardSlotIconCfg[] = [
  {
    icon: 'sheet',
    context: 'Text table',
  },
  {
    icon: 'discount-chart',
    context: 'Line chart',
  },
];

export default function useCardRightDom(
  category: '1' | '2' | (string & {}),
  props: {
    activeTab: ITabType;
    setActiveTab: React.Dispatch<React.SetStateAction<ITabType>>;
    isNoData: boolean;
    isExpandHistory: boolean;
    toggleIsExpandHistory: () => void;
  },
) {
  const { activeTab, setActiveTab, isNoData, isExpandHistory, toggleIsExpandHistory } = props;

  const rightDomOfCategory1 = (
    <>
      {APPROVED_TOTAL_DEV_BUDGET_ICON_LIST.map((iconItem, iconIndex) => {
        const { icon, context } = iconItem || {};
        const isIconActive = icon === activeTab;

        return (
          <Bubble
            key={iconIndex}
            className="dbg-bubble-max-width"
            placement="top"
            dark
            arrowPointAtCenter={false}
            content={context}
          >
            <i
              className={classnames({
                'dbg-card-slot-action': isIconActive,
                'dbg-card-slot-item': !isIconActive,
              })}
              onClick={() => {
                setActiveTab(icon);
              }}
            >
              <SvgIcon className="dbg-card-slot-charicon" type={icon} />
            </i>
          </Bubble>
        );
      })}
    </>
  );

  const rightDomOfCategory2 = isNoData ? null : (
    <TriggerFoldBtn
      foldBubble="Expand"
      contentText="Expand to View History"
      state={isExpandHistory}
      onClick={toggleIsExpandHistory}
    />
  );

  const rightDoms: IRecord<React.ReactElement | null> = {
    '1': rightDomOfCategory1,
    '2': rightDomOfCategory2,
  };

  return rightDoms[category] ?? null;
}
